import '../stylesheets/public.scss'
// for announce public registration form
import '../../assets/javascripts/legacy/map'
import '../../assets/javascripts/legacy/admin/address'

import 'jquery'
import 'jquery-ujs'
import 'bootstrap'
import { initFlash } from '../shared/flash';

$(document).ready(function() {
  initFlash()
  $('#address-map-canvas').each(function () {
    window.address.initMap($(this).closest('form'));
  });
});
